import { render, staticRenderFns } from "./firstTab.vue?vue&type=template&id=5dba595e&scoped=true&"
import script from "./firstTab.vue?vue&type=script&lang=js&"
export * from "./firstTab.vue?vue&type=script&lang=js&"
import style0 from "./firstTab.vue?vue&type=style&index=0&id=5dba595e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba595e",
  null
  
)

export default component.exports